import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

import modules from './modules/'
import actions from './actions/'

export default new Vuex.Store({
  modules,
  actions,
  mutations: {},
  plugins: [createPersistedState({
        key: 'vuex',
        paths: ['LiveWidget'],
        getState: (key, state) => window.localStorage.getItem(key),
        setState: (key, state) => window.localStorage.setItem(key, JSON.stringify(state))
    })]
})
